webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(5);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(10);
	
	var _app = __webpack_require__(12);
	
	var _auth = __webpack_require__(13);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(24);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _admin = __webpack_require__(35);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _navbar = __webpack_require__(39);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _main = __webpack_require__(43);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _baypass = __webpack_require__(46);
	
	var _baypass2 = _interopRequireDefault(_baypass);
	
	var _dashboard = __webpack_require__(49);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _app2 = __webpack_require__(14);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(16);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _maps = __webpack_require__(52);
	
	var _maps2 = _interopRequireDefault(_maps);
	
	var _bcnavbar = __webpack_require__(55);
	
	var _bcnavbar2 = _interopRequireDefault(_bcnavbar);
	
	var _sidebarnav = __webpack_require__(57);
	
	var _sidebarnav2 = _interopRequireDefault(_sidebarnav);
	
	var _baseConfig = __webpack_require__(59);
	
	var _baseConfig2 = _interopRequireDefault(_baseConfig);
	
	var _feedbackService = __webpack_require__(60);
	
	var _feedbackService2 = _interopRequireDefault(_feedbackService);
	
	var _navService = __webpack_require__(61);
	
	var _navService2 = _interopRequireDefault(_navService);
	
	__webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('epsMobileApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _auth2.default, _account2.default, _admin2.default, 'validation.match', _navbar2.default, _footer2.default, _main2.default, _baypass2.default, _maps2.default, _dashboard2.default, _bcnavbar2.default, _sidebarnav2.default, _baseConfig2.default, _navService2.default, _feedbackService2.default, _app3.default, _util2.default]).config(_app.routeConfig).run(['$rootScope', '$location', 'Auth', function ($rootScope, $location, Auth) {
	  'ngInject';
	}]);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['epsMobileApp'], {
	    strictDi: true
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(11);
	module.exports = 'validation.match';


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/*!
	 * angular-validation-match
	 * Checks if one input matches another
	 * @version v1.9.0
	 * @link https://github.com/TheSharpieOne/angular-validation-match
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, angular, undefined){'use strict';
	
	match.$inject = ["$parse"];
	angular.module('validation.match', []);
	
	angular.module('validation.match').directive('match', match);
	
	function match ($parse) {
	    return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function(scope, elem, attrs, ctrl) {
	            if(!ctrl || !attrs.match) {
	                return;
	            }
	
	            var matchGetter = $parse(attrs.match);
	            var caselessGetter = $parse(attrs.matchCaseless);
	            var noMatchGetter = $parse(attrs.notMatch);
	            var matchIgnoreEmptyGetter = $parse(attrs.matchIgnoreEmpty);
	
	            scope.$watch(getMatchValue, function(){
	                ctrl.$$parseAndValidate();
	            });
	
	            ctrl.$validators.match = function(modelValue, viewValue){
	              var matcher = modelValue || viewValue;
	              var match = getMatchValue();
	              var notMatch = noMatchGetter(scope);
	              var value;
	
	              if (matchIgnoreEmptyGetter(scope) && !viewValue) {
	                return true;
	              }
	
	              if(caselessGetter(scope)){
	                value = angular.lowercase(matcher) === angular.lowercase(match);
	              }else{
	                value = matcher === match;
	              }
	              /*jslint bitwise: true */
	              value ^= notMatch;
	              /*jslint bitwise: false */
	              return !!value;
	            };
	
	            function getMatchValue(){
	                var match = matchGetter(scope);
	                if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
	                    match = match.$viewValue;
	                }
	                return match;
	            }
	        }
	    };
	}
	})(window, window.angular);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(14);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(16);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(18);
	
	var _router = __webpack_require__(19);
	
	var _auth = __webpack_require__(20);
	
	var _user = __webpack_require__(23);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('epsMobileApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('epsMobileApp.constants', []).constant('appConfig', __webpack_require__(15)).name;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin']
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('epsMobileApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
	        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
	      }
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        (state || (state = $injector.get('$state'))).go('login');
	
	        $cookies.remove('token');
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$state', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (typeof next.authenticate === 'string') {
	      Auth.hasRole(next.authenticate).then(function (has) {
	        if (has) {
	          return;
	        }
	
	        event.preventDefault();
	        return Auth.isLoggedIn().then(function (is) {
	          $state.go(is ? 'main' : 'login');
	        });
	      });
	    } else {
	      Auth.isLoggedIn().then(function (is) {
	        if (is) {
	          return;
	        }
	
	        event.preventDefault();
	
	        $state.go('login');
	      });
	    }
	  });
	}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'appConfig', 'Util', 'User'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthService = AuthService;
	
	var _lodash = __webpack_require__(21);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	  _classCallCheck(this, _User);
	
	  this._id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = appConfig.userRoles || [];
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  if ($cookies.get('token') && $location.path() !== '/logout') {
	    currentUser = User.get();
	  }
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $http.post('/auth/local', {
	        email: email,
	        password: password
	      }).then(function (res) {
	        $cookies.put('token', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token');
	      currentUser = new _User();
	    },
	    createUser: function createUser(user, callback) {
	      return User.save(user, function (data) {
	        $cookies.put('token', data.token);
	        currentUser = User.get();
	        return safeCb(callback)(null, user);
	      }, function (err) {
	        Auth.logout();
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var is = _.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return Auth.hasRole(Reflect.apply([].concat, ['admin'], args));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('admin');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('/api/users/:id/:controller', {
	    id: '@_id'
	  }, {
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    }
	  });
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(25);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _login = __webpack_require__(29);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _settings = __webpack_require__(31);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _signup = __webpack_require__(33);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('epsMobileApp.account', [_angularUiRouter2.default, _login2.default, _settings2.default, _signup2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('login', {
	    url: '/login',
	    template: __webpack_require__(26),
	    controller: 'LoginController',
	    controllerAs: 'vm'
	  }).state('logout', {
	    url: '/logout?referrer',
	    referrer: 'main',
	    template: '',
	    controller: ['$state', 'Auth', function controller($state, Auth) {
	      'ngInject';
	
	      var referrer = $state.params.referrer || $state.current.referrer || 'main';
	      Auth.logout();
	      $state.go(referrer);
	    }]
	  }).state('signup', {
	    url: '/signup',
	    template: __webpack_require__(27),
	    controller: 'SignupController',
	    controllerAs: 'vm'
	  }).state('settings', {
	    url: '/settings',
	    template: __webpack_require__(28),
	    controller: 'SettingsController',
	    controllerAs: 'vm',
	    authenticate: true
	  });
	}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <div class=\"page-wrapper\">\n    <div class=\"row\">\n        <div class=\"login--image-panel col-md-6\">\n        </div>\n        <!-- @whitney Added this overflow style -- you can port it over to the css file and remove from here  -->\n        <div class=\"login--form-panel col-md-6\" style=\"overflow: scroll;\">\n            <div class=\"login--form-panel--head\">\n                <img class=\"login-form-panel--logo\" src=\"./assets/images/dots.svg\" alt=\"\" role=\"presentation\" />\n                <div class=\"h2\">BayREN Business Dashboards</div>\n            </div>\n            <div class=\"login--form-panel--content\">\n                <div class=\"login-form-panel--form\">\n                    <p>\n                      You are not authorized to view this content.\n                      <br><br>\n                      For access, please email Karen Kristiansson: kkristiansson@bayareametro.gov\n                    </p>\n                </div>\n                <div class=\"login-form-panel--footer\">\n                    <img class=\"footer-logo\" src=\"./assets/images/mtc_logo.svg\" alt=\"Metropolitan Transportation Commission Logo\" />\n                    <img class=\"footer-logo\" src=\"./assets/images/abag_logo.svg\" alt=\"Association of Bay Area Governments Logo\" />\n                </div>\n            </div>\n        </div>\n    </div>\n  </div>\n</section>"

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Sign up</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.register(form)\" novalidate>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && vm.submitted,\n                                            'has-error': form.name.$invalid && vm.submitted }\">\n          <label>Name</label>\n\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.user.name\"\n                 required/>\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">\n            A name is required\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.email.$valid && vm.submitted,\n                                            'has-error': form.email.$invalid && vm.submitted }\">\n          <label>Email</label>\n\n          <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\"\n                 required\n                 mongoose-error/>\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\n            Doesn't look like a valid email.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">\n            What's your email address?\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.mongoose\">\n            {{ vm.errors.email }}\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.password.$valid && vm.submitted,\n                                            'has-error': form.password.$invalid && vm.submitted }\">\n          <label>Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.password\"\n                 ng-minlength=\"3\"\n                 required\n                 mongoose-error/>\n          <p class=\"help-block\"\n             ng-show=\"(form.password.$error.minlength || form.password.$error.required) && vm.submitted\">\n            Password must be at least 3 characters.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n            {{ vm.errors.password }}\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.confirmPassword.$valid && vm.submitted,\n                                            'has-error': form.confirmPassword.$invalid && vm.submitted }\">\n          <label>Confirm Password</label>\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\n                 match=\"vm.user.password\"\n                 ng-minlength=\"3\" required/>\n          <p class=\"help-block\"\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n            Passwords must match.\n          </p>\n        </div>\n\n        <div>\n          <button class=\"btn btn-inverse btn-lg btn-register\" type=\"submit\">\n            Sign up\n          </button>\n          <a class=\"btn btn-default btn-lg btn-login\" ui-sref=\"login\">\n            Login\n          </a>\n        </div>\n\n      </form>\n    </div>\n  </div>\n  <hr>\n</div>\n"

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Change Password</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.changePassword(form)\" novalidate>\n\n        <div class=\"form-group\">\n          <label>Current Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.oldPassword\"\n                 mongoose-error/>\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n              {{ vm.errors.other }}\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>New Password</label>\n\n          <input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required/>\n          <p class=\"help-block\"\n             ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\n            Password must be at least 3 characters.\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Confirm New Password</label>\n\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\n                 match=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required=\"\"/>\n          <p class=\"help-block\"\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n            Passwords must match.\n          </p>\n\n        </div>\n\n        <p class=\"help-block\"> {{ vm.message }} </p>\n\n        <button class=\"btn btn-lg btn-primary\" type=\"submit\">Save changes</button>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(30);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('epsMobileApp.login', []).controller('LoginController', _login2.default).name;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	
	  /*@ngInject*/
	  LoginController.$inject = ['Auth', '$state'];
	  function LoginController(Auth, $state) {
	    _classCallCheck(this, LoginController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  _createClass(LoginController, [{
	    key: 'login',
	    value: function login(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.login({
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('main');
	        }).catch(function (err) {
	          _this.errors.login = err.message;
	        });
	      }
	    }
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(32);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('epsMobileApp.settings', []).controller('SettingsController', _settings2.default).name;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  SettingsController.$inject = ['Auth'];
	  function SettingsController(Auth) {
	    _classCallCheck(this, SettingsController);
	
	    this.user = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = '';
	    this.submitted = false;
	
	    this.Auth = Auth;
	  }
	
	  _createClass(SettingsController, [{
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this.message = 'Password successfully changed.';
	        }).catch(function () {
	          form.password.$setValidity('mongoose', false);
	          _this.errors.other = 'Incorrect password';
	          _this.message = '';
	        });
	      }
	    }
	  }]);
	
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(34);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('epsMobileApp.signup', []).controller('SignupController', _signup2.default).name;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupController = function () {
	
	  /*@ngInject*/
	  SignupController.$inject = ['Auth', '$state'];
	  function SignupController(Auth, $state) {
	    _classCallCheck(this, SignupController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {};
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  _createClass(SignupController, [{
	    key: 'register',
	    value: function register(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        return this.Auth.createUser({
	          name: this.user.name,
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('main');
	        }).catch(function (err) {
	          err = err.data;
	          _this.errors = {};
	
	          if (err.name) {
	            _angular2.default.forEach(err.fields, function (error, field) {
	              form[field].$setValidity('mongoose', false);
	              _this.errors[field] = err.message;
	            });
	          }
	        });
	      }
	    }
	  }]);
	
	  return SignupController;
	}();
	
	exports.default = SignupController;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(36);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(38);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('epsMobileApp.admin', ['epsMobileApp.auth', 'ui.router']).config(_admin2.default).controller('AdminController', _admin4.default).name;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('admin', {
	    url: '/admin',
	    template: __webpack_require__(37),
	    controller: 'AdminController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  });
	}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <p>The delete user and user index api routes are restricted to users with the 'admin' role.</p>\n  <ul class=\"list-group user-list\">\n    <li class=\"list-group-item\" ng-repeat=\"user in admin.users\">\n\t    <div class=\"user-info\">\n\t        <strong>{{user.name}}</strong><br>\n\t        <span class=\"text-muted\">{{user.email}}</span>\n\t    </div>\n        <a ng-click=\"admin.delete(user)\" class=\"trash\"><span class=\"fa fa-trash fa-2x\"></span></a>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminController = function () {
	  /*@ngInject*/
	  AdminController.$inject = ['User'];
	  function AdminController(User) {
	    _classCallCheck(this, AdminController);
	
	    this.users = User.query();
	  }
	
	  _createClass(AdminController, [{
	    key: 'delete',
	    value: function _delete(user) {
	      user.$remove();
	      this.users.splice(this.users.indexOf(user), 1);
	    }
	  }]);
	
	  return AdminController;
	}();
	
	exports.default = AdminController;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = ['Auth', function NavbarComponent(Auth) {
	  'ngInject';
	
	  _classCallCheck(this, NavbarComponent);
	
	  this.menu = [{
	    title: 'Home',
	    state: 'main'
	  }];
	  this.isCollapsed = true;
	  this.isLoggedIn = Auth.isLoggedInSync;
	  this.isAdmin = Auth.isAdminSync;
	  this.getCurrentUser = Auth.getCurrentUserSync;
	}];
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(40),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar sticky-top bg-body-tertiary\" style=\"background-color: #fcfcfc;\">\n  <div class=\"container\">\n    <div class=\"navbar-header\">\n      <!-- <button class=\"navbar-toggle\" type=\"button\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\">\n        <span class=\"sr-only\">Toggle navigation</span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n      </button> -->\n      <a href=\"/\" class=\"navbar-brand\"> <img src=\"https://docs.clippercard.com/brand/brand-logo-stacked-bw.png\" alt=\"Logo\" width=\"20%\" height=\"20%\" class=\"d-inline-block align-text-middle\">\n        Data Store</a>\n    </div>\n    <div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\">\n      <ul class=\"nav navbar-nav\">\n        <li ng-repeat=\"item in $ctrl.menu\" ui-sref-active=\"active\">\n            <a ui-sref=\"{{item.state}}\">{{item.title}}</a>\n        </li>\n        <li ng-show=\"$ctrl.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"admin\">Admin</a></li>\n      </ul>\n\n      <ul class=\"nav navbar-nav navbar-right\">\n        <li ng-hide=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"signup\">Sign up</a></li>\n        <li ng-hide=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"login\">Login</a></li>\n        <li ng-show=\"$ctrl.isLoggedIn()\"><p class=\"navbar-text\">Hello {{ $ctrl.getCurrentUser().name }}</p> </li>\n        <li ng-show=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"settings\"><span class=\"glyphicon glyphicon-cog\"></span></a></li>\n        <li ng-show=\"$ctrl.isLoggedIn()\"><a ui-sref=\"logout\">Logout</a></li>\n      </ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = function FooterComponent() {
	  _classCallCheck(this, FooterComponent);
	};
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(42),
	  controller: FooterComponent
	}).name;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <p>Angular Fullstack v4.2.2 |\n    <a href=\"http://angular-fullstack.github.io/\">Documentation</a> |\n    <a href=\"https://gitter.im/DaftMonk/generator-angular-fullstack\">Chat on Gitter</a> |\n    <a href=\"https://github.com/angular-fullstack/generator-angular-fullstack/issues?state=open\">Issues</a> |\n    <a href=\"https://opencollective.com/angular-fullstack\">Donate to our Open Collective</a>\n  </p>\n</div>\n"

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(44);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	  /*@ngInject*/
	  MainController.$inject = ['$http', '$scope', '$location', 'baseConfigService', 'navService'];
	  function MainController($http, $scope, $location, baseConfigService, navService) {
	    _classCallCheck(this, MainController);
	
	    this.$http = $http;
	    this.$scope = $scope;
	    this.$location = $location;
	
	    this.baseConfigService = baseConfigService;
	    this.navService = navService;
	  }
	
	  _createClass(MainController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.$scope.params = this.$location.search();
	      this.loadIframe(this.$scope.params);
	      this.$scope.page = this.navService.getPage();
	      console.log("this is the page: ", this.$scope.page);
	      this.$scope.embedId = this.$location.search().embedId;
	      console.log(this.$scope.embedId);
	    }
	  }, {
	    key: 'loadIframe',
	    value: function loadIframe(params) {
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      var embedId = params.embedId;
	      var $scope = this.$scope;
	
	      this.$scope.pageDetails = this.navService.getDetails(embedId);
	      this.$scope.title = 'Bay Area Existing Buildings Study';
	    }
	  }]);
	
	  return MainController;
	}();
	
	exports.default = _angular2.default.module('epsMobileApp.main', [_angularUiRouter2.default]).config(_main2.default).component('main', {
	  template: __webpack_require__(45),
	  controller: MainController
	}).name;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/',
	    template: '<main></main>'
	  });
	}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "<style>\n    .dashboard .main {\n        height: 100% !important;\n    }\n\n        /* Set the tableau container to take full width and height */\n        .container-fluid {\n        height: 100vh; /* full viewport height */\n        padding-left: 250px; /* Keep your padding intact */\n    }\n    \n   \n\n</style>\n<section class=\"dashboard\">\n    <div class=\"page-wrapper\">\n        <div class=\"dashboard-header\">\n            <sidebarnav />\n        </div>\n        <div class=\"main\">\n            <!-- Add breadcrumb navigation bar via directive  -->\n            <bcnavbar></bcnavbar>\n\n            <div class=\"container-fluid\" style=\"padding-left:250px;\">\n                <div class=\"row\">\n                   <div class=\"col-md-12\">\n                    <div class='tableauPlaceholder' id='viz1734647267824' style='position: relative; overflow: scroll;'><noscript><a href='#'><img alt=' ' src='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;Ba&#47;BayAreaExistingBuildingsStudy09102024&#47;Overview&#47;1_rss.png' style='border: none' /></a></noscript><object class='tableauViz'  style='display:none;'><param name='host_url' value='https%3A%2F%2Fpublic.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='' /><param name='name' value='BayAreaExistingBuildingsStudy09102024&#47;Overview' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='static_image' value='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;Ba&#47;BayAreaExistingBuildingsStudy09102024&#47;Overview&#47;1.png' /> <param name='animate_transition' value='yes' /><param name='display_static_image' value='yes' /><param name='display_spinner' value='yes' /><param name='display_overlay' value='yes' /><param name='display_count' value='yes' /><param name='language' value='en-US' /></object></div>                <script type='text/javascript'>                    var divElement = document.getElementById('viz1734647267824');                    var vizElement = divElement.getElementsByTagName('object')[0];                    if ( divElement.offsetWidth > 800 ) { vizElement.style.width='1200px';vizElement.style.height='750px';} else if ( divElement.offsetWidth > 500 ) { vizElement.style.width='1200px';vizElement.style.height='750px';} else { vizElement.style.width='100%';vizElement.style.height='3000px';}                     var scriptElement = document.createElement('script');                    scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';                    vizElement.parentNode.insertBefore(scriptElement, vizElement);                </script>\n                   </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <div class=\"container\">\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <p>Powered by:</p>\n                    </div>\n                    <div class=\"col-6 col-lg-12\">\n                        <p><a href=\"https://mtc.ca.gov\" title=\"Metropolitan Transportation Commission\" target=\"_blank\"\n                                rel=\"noopener noreferrer\"><img class=\"logo-mtc\"\n                                    alt=\"Metropolitan Transportation Commission logo\"\n                                    src=\"./../../assets/images/mtc_footer_logo.svg\"><img\n                                    class=\"logo-mtc logo-mtc--dashboard-light\"\n                                    alt=\"Metropolitan Transportation Commission logo\" src=\"../images/mtc_logo.svg\"></a>\n                        </p>\n                    </div>\n                    <div class=\"col-6 col-lg-12\">\n                        <p><a href=\"https://abag.ca.gov/\" target=\"_blank\" rel=\"noopener noreferrer\"><img\n                                    class=\"logo-abag\" title=\"Association of Bay Area Governments\"\n                                    alt=\"Association of Bay Area Governments logo\"\n                                    src=\"./../../assets/images/abag_footer_logo.svg\"><img\n                                    class=\"logo-abag logo-abag--dashboard-light\"\n                                    title=\"Association of Bay Area Governments\"\n                                    alt=\"Association of Bay Area Governments logo\" src=\"../images/abag_logo.svg\"></a>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>"

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BaypassComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _baypass = __webpack_require__(47);
	
	var _baypass2 = _interopRequireDefault(_baypass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var BaypassComponent = exports.BaypassComponent = function () {
	  /*@ngInject*/
	  BaypassComponent.$inject = ['$http', '$scope'];
	  function BaypassComponent($http, $scope) {
	    _classCallCheck(this, BaypassComponent);
	
	    this.$http = $http;
	    this.$scope = $scope;
	
	    $scope.updateCharts = function () {
	
	      if (!$scope.startDate) {
	        $scope.startDate = document.getElementById('start').value;
	      } else {
	        $scope.startDate = $scope.startDate;
	      }
	
	      if (!$scope.endDate) {
	        $scope.endDate = document.getElementById('end').value;
	      } else {
	        $scope.endDate = $scope.endDate;
	      }
	
	      $scope.params = {
	        startDate: $scope.startDate.toISOString().split('T')[0],
	        endDate: $scope.endDate.toISOString().split('T')[0]
	      };
	
	      console.log($scope.params);
	
	      $http.post('/api/data/baypass/params', $scope.params).then(function (response) {
	        console.log(response.data);
	
	        document.getElementById('wleFrame').src = response.data;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    };
	  }
	
	  _createClass(BaypassComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var http = this.$http;
	
	      $('#multiSelect').select2();
	
	      this.$scope.loadIframe = function () {
	        var startDate = '2022-10-01';
	        var endDate = '2022-12-31';
	
	        http.get('/api/data/baypass/' + startDate + '/' + endDate).then(function (response) {
	          document.getElementById('wleFrame').src = response.data;
	        }).catch(function (error) {
	          console.log(error);
	        });
	      };
	
	      this.$scope.loadIframe();
	    }
	  }]);
	
	  return BaypassComponent;
	}();
	
	exports.default = angular.module('appApp.baypass', [uiRouter]).config(_baypass2.default).component('baypass', {
	  template: __webpack_require__(48),
	  controller: BaypassComponent,
	  controllerAs: 'baypassCtrl'
	}).name;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('baypass', {
	    url: '/baypass',
	    template: '<baypass></baypass>'
	  });
	}];

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"row mt-5\">\r\n    <div class=\"col-md-2\">\r\n      \r\n    </div>\r\n    <div class=\"col-md-8\">\r\n      <h3>Clipper BayPass Dashboard</h3>\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-12 col-md-4\">\r\n          <div class=\"mb-3\">\r\n            <label for=\"dateopen\" class=\"control-label col-form-label\">Start Date</label>\r\n            <input type=\"date\" class=\"form-control\" id=\"dateopen\" ng-model=\"startDate\">\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-12 col-md-4\">\r\n          <div class=\"mb-3\">\r\n            <label for=\"datefixe\" class=\"control-label col-form-label\">End Date</label>\r\n            <input type=\"date\" class=\"form-control\" id=\"datefixe\" ng-model=\"endDate\">\r\n          </div>\r\n        </div>\r\n        \r\n      </div>\r\n      <button class=\"btn btn-outline-secondary\" type=\"button\" ng-click=\"updateCharts()\">Run Report</button>\r\n     \r\n     <div id='wleContainer'>\r\n       <iframe id=\"wleFrame\" src=\"\" style=\"width: 100%;height: 85vh;position: relative; padding-top: 50px;\" frameborder=\"0\" class=\"mode-embed\"></iframe>\r\n     </div>\r\n    </div>\r\n    <div class=\"col-md-2\"> \r\n      \r\n    </div>\r\n\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DashboardComponent = undefined;
	
	var _dashboard = __webpack_require__(50);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var DashboardComponent =
	/*@ngInject*/
	exports.DashboardComponent = function DashboardComponent() {
	  _classCallCheck(this, DashboardComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.dashboard', [uiRouter]).config(_dashboard2.default).component('dashboard', {
	  template: __webpack_require__(51),
	  controller: DashboardComponent,
	  controllerAs: 'dashboardCtrl'
	}).name;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('dashboard', {
	    url: '/dashboard',
	    template: '<dashboard></dashboard>'
	  });
	}];

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = "<div>This is the dashboard view.</div>\r\n"

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MapsComponent = undefined;
	
	var _maps = __webpack_require__(53);
	
	var _maps2 = _interopRequireDefault(_maps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var MapsComponent =
	/*@ngInject*/
	exports.MapsComponent = function MapsComponent() {
	  _classCallCheck(this, MapsComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.maps', [uiRouter]).config(_maps2.default).component('maps', {
	  template: __webpack_require__(54),
	  controller: MapsComponent,
	  controllerAs: 'mapsCtrl'
	}).name;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('maps', {
	    url: '/maps',
	    template: '<maps></maps>'
	  });
	}];

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--content--housing\">\r\n    <div class=\"page-wrapper\">\r\n        <sidebarnav></sidebarnav>\r\n        \r\n        <style>\r\n            .dashboard .main {\r\n            height: 100% !important;\r\n        } \r\n        </style> \r\n        <div class=\"main\">\r\n            <!-- Add breadcrumb navigation bar via directive  -->\r\n           <bcnavbar></bcnavbar>\r\n            <div class=\"content container\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-12\">\r\n                      <h2>{{metadata.descriptionTitle[0]}}</h2>\r\n                      <p>{{metadata.description[0]}}</p>\r\n                  </div>\r\n                    <div class=\"col-12\">\r\n                        <!-- <h1 class=\"page-title\">Dashboard </h1>\r\n                        <div class=\"page-summary\">Affordable Housing Production, Preservation, and Protection and Commercial Stabilization</div> -->\r\n                        <div id=\"map\">\r\n                            <style>.embed-container {position: relative; padding-bottom: 80%; height: 0; max-width: 100%;} .embed-container iframe, .embed-container object, .embed-container iframe{position: absolute; top: 0; left: 0; width: 100%; height: 100%;} small{position: absolute; z-index: 40; bottom: 0; margin-bottom: -15px;}</style><div class=\"embed-container\"><iframe width=\"500\" height=\"400\" frameborder=\"0\" scrolling=\"no\" marginheight=\"0\" marginwidth=\"0\" title=\"Clipper Retail October 2023\" src=\"https://www.arcgis.com/apps/instant/interactivelegend/index.html?appid=1fc689da1b4c4692b994c8daa7aadfe8\"></iframe></div>\r\n\r\n                        </div>\r\n                        \r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    \r\n    </div>\r\n    <div class=\"footer\" role=\"contentinfo\">\r\n        <!-- footer start -->\r\n        <div class=\"container\">\r\n            <div class=\"row\">\r\n                <div class=\"col-12\">\r\n                    <p>Powered by:</p>\r\n                </div>\r\n                <div class=\"col-6 col-lg-12\">\r\n                    <p><a href=\"https://mtc.ca.gov\" title=\"Metropolitan Transportation Commission\" target=\"_blank\" rel=\"noopener noreferrer\"><img class=\"logo-mtc\" alt=\"Metropolitan Transportation Commission logo\" src=\"../assets/images/mtc_footer_logo.svg\"></a></p>\r\n                </div>\r\n                <div class=\"col-6 col-lg-12\">\r\n                    <p><a href=\"https://abag.ca.gov/\" target=\"_blank\" rel=\"noopener noreferrer\"><img class=\"logo-abag\" title=\"Association of Bay Area Governments\" alt=\"Association of Bay Area Governments logo\" src=\"../assets/images/abag_footer_logo.svg\"></a></p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <!-- footer end -->\r\n    </div>\r\n</section>"

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var BCNavbarComponent = exports.BCNavbarComponent = function () {
	  BCNavbarComponent.$inject = ['$state', '$cookies', '$scope', '$rootScope', 'navService'];
	  function BCNavbarComponent($state, $cookies, $scope, $rootScope, navService) {
	    'ngInject';
	
	    _classCallCheck(this, BCNavbarComponent);
	
	    this.menu = [{
	      title: 'Home',
	      url: 'main'
	    }];
	    this.isCollapsed = true;
	  }
	
	  _createClass(BCNavbarComponent, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return BCNavbarComponent;
	}();
	
	exports.default = angular.module('appApp.bcnavbar', []).directive('bcnavbar', function () {
	  return {
	    template: __webpack_require__(56),
	    controller: BCNavbarComponent,
	    controllerAs: 'bcnavbarCtrl',
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = "<style>\n    @media (min-width: 992px) {\n    .header__actions {\n        position: fixed;\n        top: 8px;\n        right: 0;\n        background: transparent;\n        width: 375px;\n        z-index: 4\n    }\n}\n\n@media (min-width: 992px) {\n    .page-wrapper:before {\n        position: fixed;\n        z-index: 3;\n    }\n}\n\n</style>\n<div class=\"header__actions\">\n    <!-- <nav class=\"header__account-nav\">\n        <div class=\"dropdown\">\n            <button class=\"btn btn-secondary dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n                {{bcnavbarCtrl.getCurrentUser().firstname}} {{bcnavbarCtrl.getCurrentUser().lastname}}\n            </button>\n            <ul class=\"dropdown-menu\">\n                <li><span class=\"dropdown-item\">{{bcnavbarCtrl.getCurrentUser().email}}</span></li>\n                <li><a class=\"dropdown-item dropdown-item--icon dropdown-item--account\" href=\"/account/myaccount\">Account Settings</a></li>\n                <li><a class=\"dropdown-item dropdown-item--icon dropdown-item--exit\" href=\"/logout\">Sign Out</a></li>\n            </ul>\n        </div>\n    </nav> -->\n    <!-- <div class=\"header__configuration-trigger\">\n        <div class=\"dropdown\">\n        <button class=\"toggle--configuration-nav\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><span class=\"visually-hidden\">Toggle Configuration Navigation</span></button>\n        <ul class=\"dropdown-menu\">\n            <li><a class=\"dropdown-item dropdown-item--icon dropdown-item--account\" href=\"/admin/manageusers\">Manage Users</a></li>\n            <li><a class=\"dropdown-item dropdown-item--icon dropdown-item--exit\" href=\"/admin/manageusers\">Manage Submissions</a></li>\n            <li><a class=\"dropdown-item dropdown-item--icon dropdown-item--exit\" href=\"/admin/manageusers\">Manage Feedback</a></li>\n        </ul>\n        </div>\n    </div> -->\n    <!-- TODO: is this a dropdown or a link to a page? -->\n</div>\n<div class=\"breadcrumb-container\">\n    <nav aria-label=\"breadcrumb\">\n        <ol class=\"breadcrumb\">\n            <li ng-if=\"title\" class=\"breadcrumb-item active\" aria-current=\"page\">{{title}}</li>\n            <!-- <li class=\"breadcrumb-item\"><a ng-href=\"/\">{{subItem.title}}</a></li> -->\n            <!-- <li ng-show=\"breadCrumb.subItem1\" class=\"breadcrumb-item\"><a ng-href=\"{{breadCrumb1.url}}\">{{pageTitleLvl2}}</a></li> -->\n         </ol>\n    </nav>\n</div>"

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var SideNavbarComponent = exports.SideNavbarComponent = function () {
	  SideNavbarComponent.$inject = ['$http', '$state', '$cookies', '$scope', '$rootScope', 'navService', '$location', 'baseConfigService'];
	  function SideNavbarComponent($http, $state, $cookies, $scope, $rootScope, navService, $location, baseConfigService) {
	    'ngInject';
	
	    _classCallCheck(this, SideNavbarComponent);
	
	    this.$state = $state;
	    this.$http = $http;
	    this.$scope = $scope;
	    this.$location = $location;
	    this.$rootScope = $rootScope;
	
	    this.navService = navService;
	    this.baseConfigService = baseConfigService;
	  }
	
	  _createClass(SideNavbarComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$scope.menu = this.navService.getSideBarNav();
	      if (!this.$rootScope.page) {
	        this.$rootScope.page = _.filter(this.$scope.menu, { url: this.$location.path() })[0];
	        console.log(this.$rootScope.page);
	      }
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(page) {
	      console.log(page, " :: page");
	      this.$location.url('/?embedId=' + page.url);
	      this.loadIframe(page);
	      console.log(this.$location.search());
	      this.$scope.page = page;
	      this.navService.setPage(page);
	
	      console.log('sidebar: ', this.$scope.$root);
	    }
	  }, {
	    key: 'loadIframe',
	    value: function loadIframe(params) {
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      var embedId = params.url;
	      var $scope = this.$scope;
	
	      this.$scope.pageDetails = this.navService.getDetails(embedId);
	
	      this.$http.get(adminBaseURL + '/embed/tableau/' + embedId).then(function (response) {
	        var embedInfo = response.data;
	        console.log(embedInfo);
	        $scope.title = embedInfo.name;
	        $scope.token = embedInfo.token;
	        document.getElementById('tableau-viz').token = embedInfo.token;
	        document.getElementById('tableau-viz').src = embedInfo.url;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }
	  }, {
	    key: 'updateBreadcrumb',
	    value: function updateBreadcrumb(subItem, item) {
	      console.log(subItem);
	      console.log(item);
	      this.$rootScope.page = item;
	      this.$rootScope.subItem = subItem;
	      this.$location.url(subItem.url);
	      this.showSubNav(item);
	      this.subNavActive(item, subItem);
	    }
	  }, {
	    key: 'showSubNav',
	    value: function showSubNav(page) {
	      this.$scope.menu.forEach(function (item) {
	        if (item.title === page.title) {
	          item.expanded = true;
	        } else {
	          item.expanded = false;
	        }
	      });
	    }
	  }, {
	    key: 'subNavActive',
	    value: function subNavActive(page, subItem) {
	      console.log(page);
	      if (page.subItem1) {
	        page.subItem1.forEach(function (subnav) {
	          if (subnav.title === subItem.title) {
	            subnav.active = true;
	          } else {
	            subnav.active = false;
	          }
	        });
	      }
	    }
	  }]);
	
	  return SideNavbarComponent;
	}();
	
	exports.default = angular.module('appApp.sidebarnav', []).directive('sidebarnav', ['$rootScope', function ($rootScope) {
	  return {
	    template: __webpack_require__(58),
	    controller: SideNavbarComponent,
	    controllerAs: 'sidebarnavCtrl',
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {
	      scope.$watch('page', function () {
	        console.log($rootScope.page);
	        scope.page = $rootScope.page;
	      });
	      scope.$watch('subItem', function () {
	        console.log($rootScope.subItem);
	        scope.subItem = $rootScope.subItem;
	      });
	    }
	  };
	}]).name;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"header__branding\">\n    <div class=\"container\">\n        <div class=\"header__logo\">\n            <img class=\"logo\" src=\"../../../assets/images/BayREN_logo_no-tag.png\" style=\"width:160px;height:81px;\" alt=\"\" role=\"presentation\" />\n            <!-- <div class=\"header__title\">BayREN Data Visualizations</div> -->\n        </div>\n    </div>\n    <div class=\"header__navigation\">\n        <nav class=\"navbar navbar-expand-lg\">\n            <button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarNavDropdown\" aria-controls=\"navbarNavDropdown\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n                <span class=\"navbar-toggler-icon\"></span>\n            </button>\n            <div class=\"navbar-collapse\" id=\"navbarNavDropdown\">\n                <div class=\"row\">\n                <a href=\"https://forms.gle/2dYwYaxW6jEPx2uj7\" target=\"_blank\" class=\"btn btn-secondary\" style=\"margin-bottom:2px;\">Provide Feedback</a>\n                <a href=\"https://forms.gle/2dYwYaxW6jEPx2uj7\" target=\"_blank\" class=\"btn btn-secondary\">Report a Problem</a>\n                </div>\n                <div class=\"nav-heading\">Explore Visualizations</div>\n                <ul class=\"nav nav--explore flex-column\">\n                    <li class=\"nav-item has-submenu\" ng-repeat=\"item in menu\">\n                        <a href=\"#\" class=\"nav-link nav-link--icon {{item.navLinkIconClass}}\">\n                            {{ item.title }}\n                        </a>\n                        <button ng-if=\"item.subItem1\" type=\"button\" class=\"dropdown-toggle\" data-bs-toggle=\"collapse\" data-bs-target=\"#item_{{$index}}_menu\" aria-expanded=\"true\">\n                            <span class=\"visually-hidden\">Show submenu for BayREN</span>\n                        </button>\n                        <ul ng-if=\"item.subItem1\" class=\"collapse-menu collapse\" id=\"item_{{$index}}_menu\" ng-class=\"{ 'show': item.expanded }\">\n                          <li ng-repeat=\"subItem in item.subItem1\">\n                            <a class=\"dropdown-item\" href=\"#\" ng-class=\"{'active': subItem.active}\" ng-click=\"sidebarnavCtrl.gotoPage(subItem)\">{{subItem.title}}</a>\n                          </li>\n                        </ul>\n                    </li>\n                   \n                </ul>\n                <ul class=\"nav nav--tools flex-column\">\n                    <li class=\"nav-item has-submenu\">\n                        <a href=\"#\" class=\"nav-link\">\n                            About the Tools\n                        </a>\n                        <button type=\"button\" class=\"dropdown-toggle collapsed\" data-bs-target=\"#toolsMenu\" data-bs-toggle=\"collapse\" aria-expanded=\"false\">\n                            <span class=\"sr-only\">Show/hide submenu for Using the Tools</span>\n                        </button>\n                        <ul class=\"collapse-menu collapse\" id=\"toolsMenu\">\n                            <li><a class=\"dropdown-item\" href=\"mailto:kkristiansson@bayareametro.gov\">Contact Karen Kristiansson with any questions!</a></li>\n                        </ul>\n                    </li>\n                </ul>\n            </div>\n        </nav>\n    </div>\n  </div>"

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.baseConfigService = baseConfigService;
	var angular = __webpack_require__(1);
	
	var baseUrl = 'https://jsapi.mtcanalytics.org:10000';
	var adminBaseURL = 'https://jsapi.mtcanalytics.org:11000';
	
	/*@ngInject*/
	function baseConfigService() {
	  this.getBaseURL = function () {
	    return baseUrl;
	  };
	
	  this.getAdminBaseURL = function () {
	    return adminBaseURL;
	  };
	}
	
	exports.default = angular.module('appApp.baseConfig', []).service('baseConfigService', baseConfigService).name;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	feedbackServiceService.$inject = ['baseConfigService', '$http'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.feedbackServiceService = feedbackServiceService;
	var angular = __webpack_require__(1);
	
	
	var adminBaseURL;
	
	/*@ngInject*/
	function feedbackServiceService(baseConfigService, $http) {
	    adminBaseURL = baseConfigService.getAdminBaseURL();
	
	    this.getAllFeedback = function () {
	        return $http.get(adminBaseURL + '/feedback');
	    };
	
	    this.getFeedback = function (id) {
	        return $http.get(adminBaseURL + '/feedback/' + id);
	    };
	
	    this.createFeedback = function () {
	        return $http.post(adminBaseURL + '/feedback');
	    };
	
	    this.updateFeedback = function (id) {
	        return $http.post(adminBaseURL + '/feedback/' + id);
	    };
	
	    this.deleteFeedback = function (id) {
	        return $http.delete(adminBaseURL + '/feedback/' + id);
	    };
	
	    this.addFeedbackTo = function (id, type) {
	        return $http.post(adminBaseURL + '/feedback/' + type + '/' + id);
	    };
	}
	
	exports.default = angular.module('appApp.feedbackService', []).service('feedbackService', feedbackServiceService).name;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.navServiceService = navServiceService;
	var angular = __webpack_require__(1);
	
	var page = {};
	
	var sideBarNav = [{
	  title: 'Dashboards',
	  url: '/?embedId=bed8092e-76f6-4a76-be36-586284fdd24b',
	  dropdown: true,
	  navLinkIconClass: 'nav-link--housing',
	  show: 'loggedIn',
	  expanded: true,
	  subItem1: [{
	    title: 'Study Overview',
	    url: 'bed8092e-76f6-4a76-be36-586284fdd24b',
	    description: ""
	  }]
	}];
	/*@ngInject*/
	function navServiceService() {
	  this.getSideBarNav = function () {
	    return sideBarNav;
	  };
	
	  this.getPage = function () {
	    return page;
	  };
	
	  this.setPage = function (page) {
	    console.log('setting page: ', page);
	    page = page;
	  };
	
	  this.getDetails = function (id) {
	    if (_.filter(sideBarNav[0].subItem1, { url: id })[0]) {
	      return _.filter(sideBarNav[0].subItem1, { url: id })[0];
	    }
	  };
	}
	
	exports.default = angular.module('appApp.navService', []).service('navService', navServiceService).name;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
]);


// WEBPACK FOOTER //
// app.c0f60700b4322c664757.js